var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmexSmall = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 16,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 16,
  fill: "#1F72CD",
  rx: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M4.349 6 2.625 9.991h2.064l.255-.636h.585l.256.636h2.272v-.486l.202.486h1.175l.202-.496v.496h4.724l.575-.62.538.62 2.426.005-1.73-1.99L17.9 6H15.51l-.559.608-.52-.608H9.29L8.85 7.03 8.398 6h-2.06v.47L6.11 6zm.399.568h1.006l1.143 2.706V6.568H8l.883 1.94.814-1.94h1.097V9.43h-.667l-.006-2.244-.972 2.244H8.55l-.978-2.244v2.244H6.2l-.26-.642H4.534l-.26.642H3.54zm9.368 0h-2.713V9.43h2.67l.862-.949.83.949h.867l-1.26-1.423 1.26-1.44h-.83l-.856.938zm-8.879.484-.463 1.144H5.7zm6.836.63V7.16h1.693l.739.836-.772.84h-1.66v-.57h1.48v-.583z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmexSmall);
export default ForwardRef;